import React, { FunctionComponent } from 'react'

import { faTrash } from '@fortawesome/pro-regular-svg-icons'

import styled from 'styled-components/native'
import { FaIcon } from '../../../../App/Components'

type Props = {
  isShowRemoveIcon: boolean
  highlightcolor: string
  removeActivity: () => void
}

const RemoveActivityContainer = styled.Text<{
  highlightcolor: string
}>`
  margin-left: 10px;
  color: ${({ highlightcolor }) =>
    highlightcolor ? highlightcolor + 15 : '#fff'};
`

export const RemoveActivityIcon: FunctionComponent<Props> = ({
  isShowRemoveIcon,
  highlightcolor,
  removeActivity,
}) => {
  if (!isShowRemoveIcon) {
    return null
  }

  return (
    <RemoveActivityContainer
      highlightcolor={highlightcolor}
      onPress={removeActivity}
    >
      <FaIcon size="sm" color="#d24444" icon={faTrash} />
    </RemoveActivityContainer>
  )
}
